import { createMuiTheme } from '@material-ui/core';

export default createMuiTheme({
  palette: {
    background: {
      default: '#202935!important',
    },
    text: {
      primary: '#1e1e1e',
      secondary: '#5d7599',
    },
  },
  typography: {
    // @ts-ignore
    color: '#1e1e1e',
    fontFamily: 'Source Sans Pro',
    fontSize: 13,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.23,
    letterSpacing: 'normal',
    body1: {},
    body2: {},
  },
  overrides: {
    MuiButton: {
      root: {
        height: 40,
        padding: '12px 16px',
        borderRadius: '2px',
        fontFamily: 'Source Sans Pro',
        fontSize: '12px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.33,
        letterSpacing: 1,
        textAlign: 'center',
        whiteSpace: 'nowrap',
        flexShrink: 0,
      },
      containedPrimary: {
        backgroundColor: '#5d7599',
        color: '#ffffff',
        '&:hover': {
          backgroundColor: '#455772',
        },
        '&:active': {
          backgroundColor: '#37465b',
        },
        '&:focus': {
          backgroundColor: '#5d7599',
        },
        '&$disabled': {
          backgroundColor: '#d7dde6',
          color: '#ffffff',
        },
      },
      outlinedPrimary: {
        borderColor: '#5d7599',
        border: '2px solid',
        color: '#5d7599',
        '&:hover': {
          borderColor: '#455772',
        },
        '&:active': {
          borderColor: '#37465b',
        },
        '&:focus': {
          borderColor: '#5d7599',
        },
        '&$disabled': {
          borderColor: '#d7dde6',
          color: '#d7dde6',
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        '& fieldset': {
          borderColor: '#949494',
          borderWidth: 2,
        },
      },
    },
  },
});
